import { Component, inject, signal } from '@angular/core';
import { FormField, email, form, minLength, required, submit, validate } from '@angular/forms/signals';

import { AuthService } from '../../shared/services/auth.service';
import { environment } from '../../../environments/environment';
import { MatCard, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatFormField, MatLabel, MatInput, MatError, MatSuffix } from '@angular/material/input';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AuthStore } from '../../shared/state/auth.store';
import { UiStore } from '../../shared/state/ui.store';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [MatCard, MatCardTitle, MatCardContent, FormField, MatFormField, MatLabel, MatInput, MatError, MatIconButton, MatSuffix, MatIcon, MatCardActions, MatButton]
})
export class LoginComponent {
  private readonly authStore = inject(AuthStore);
  private readonly uiStore = inject(UiStore);
  private authServ = inject(AuthService);

  prod = environment.production;
  private readonly credentiale = signal({ email: '', password: '' });
  protected readonly userForm = form(this.credentiale, p => {
    required(p.email);
    email(p.email);
    required(p.password);
    minLength(p.password, 8);
    // fara maxLength(): acela ar pune maxlength pe input si ar taia textul lipit
    validate(p.password, ({ value }) => value().length > 32 ? { kind: 'maxLength', message: 'Parola este invalidă' } : undefined);
  });
  protected readonly show = signal(false);
  protected readonly isLoading = this.uiStore.isLoading;

  onLogin() {
    submit(this.userForm, async () => {
      if (!this.isLoading()) {
        this.authServ.login(this.credentiale());
      }
    });
  }

  // ---- toggle
  toggleAuth() {
    this.authStore.clear();
  }

  toggleShow() {
    this.show.update(show => !show);
  }
}
